<template>
	<div class="container">
		<section class="content">
			<h2>Info societarie</h2>
			a) ragione sociale e codice fiscale: Quomi Srl, 08635750964
 
			b) data e luogo di costituzione, nome e indirizzo del notaio; 17/04/2017, Milano, viale Monte Santo 1 / 3 , Dott. Avv. Pier Paolo Corradini
			 
			c) sede principale ed eventuali sedi periferiche; Via Abbondio Sangiorgio 12, 20145 Milano
			 
			d) oggetto sociale: SVILUPPO, LA PRODUZIONE E LA COMMERCIALIZZAZIONE DI PRODOTTI E SERVIZI INNOVATIVI AD ALTO VALORE TECNOLOGICO. NELL'AMBITO DI TALE OGGETTO, LA SOCIETÀ POTRÀ SVOLGERE, IN PARTICOLARE: - LO SVILUPPO, LA PRODUZIONE E LA COMMERCIALIZZAZIONE DI PRODOTTI O SERVIZI INNOVATIVI E DI DESIGN LEGATI AL COMMERCIO ELETTRONICO E NON, MEDIANTE L'UTILIZZO DI TECNOLOGIE INNOVATIVE, CON PARTICOLARE RIFERIMENTO AI PRODOTTI ALIMENTARI, ALLE BEVANDE ED AI PRODOTTI ALCOLICI E NON ALCOLICI; - LA PREDISPOSIZIONE E LA REALIZZAZIONE DI UN SISTEMA LOGISTICO INNOVATIVO AVENTE AD OGGETTO PREVALENTEMENTE IL PACKAGING E LA SPEDIZIONE PER LA GESTIONE DEI PRODOTTI ALIMENTARI ANCHE AD ALTA DETERIORABILITÀ, NONCHÉ' OGNI ATTIVITÀ DIRETTA A SVILUPPARE L ATTIVITÀ DI CUI AL PUNTO PRECEDENTE; - LO SVILUPPO DI APPLICAZIONI PER LA TELEFONIA MOBILE
			E SERVIZI DIGITALI INTEGRATI FUNZIONALIZZATI A FAVORIRE LA COMMERCIALIZZAZIONE DI PRODOTTI ALIMENTARI E BEVANDE ALCOLICHE E NON. LA SOCIETÀ PUO' COMPIERE TUTTE LE OPERAZIONI COMMERCIALI, IMMOBILIARI E FINANZIARIE CHE SARANNO RITENUTE UTILI DALL'ORGANO AMMINISTRATIVO PER IL CONSEGUIMENTO DELL'OGGETTO SOCIALE, NONCHÉ' ASSUMERE INTERESSENZE O PARTECIPAZIONI IN ALTRE SOCIETÀ AVENTI OGGETTO
			ANALOGO O CONNESSO AL PROPRIO, CON ESCLUSIONE DI ATTIVITÀ FINANZIARIE NEI CONFRONTI DEL PUBBLICO.

			e) breve descrizione dell’attività svolta, comprese l’attività e le spese di ricerca, sviluppo e innovazione; SVILUPPO, PRODUZIONE E VENDITA DI PIATTAFORME INFORMATICHE ED APPLICATIVE MOBILI PER PROMUOVERE LA VENDITA AI CONSUMATORI BUSINESS E PRIVATI DI PRODOTTI CONNESSI AL MERCATO ALIMENTARE IN GENERE; LE PIATTAFORME INFORMATICHE E APPLICATIVE SVILUPPATE SI PONGONO LO SCOPO DI: 
			A. GESTIRE IL FLUSSO DI INFORMAZIONI (TESTUALI, GRAFICHE ED ICONOGRAFICHE) NECESSARIE PER LA PROPOSTA IN VENDITA DEI PRODOTTI OFFERTI;
			B. GESTIRE IL SISTEMA DELLE TRANSAZIONI FINANZIARIE INTERCORSE;
			C. GESTIRE IL SISTEMA LOGISTICO DEI PRODOTTI VENDUTI;
			D. GESTIRE IL SISTEMA DEI RESI DEI PRODOTTI VENDUTI.
			 
			f) elenco dei soci, con trasparenza rispetto a società fiduciarie e holding ove non iscritte nel registro delle imprese di cui all’articolo 8 della legge 29 dicembre 1993, n. 580, e successive modificazioni, con autocertificazione di veridicità, indicando altresì, per ciascuno e ove sussistano, gli eventuali soggetti terzi per conto dei quali, nel cui interesse o sotto il cui controllo il socio agisce:

			<table>
				<tr>
					<td>
						Andrea
					</td>
					<td>
						Bruno
					</td>
				</tr>
				<tr>
					<td>
						Daniele
					</td>
					<td>
						Bruttini
					</td>
				</tr>
				<tr>
					<td>
						Gianfranco
					</td>
					<td>
						Ritucci
					</td>
				</tr>
				<tr>
					<td>
						Umberto
					</td>
					<td>
						Saraval
					</td>
				</tr>
				<tr>
					<td>
						Panda
					</td>
					<td>
						Srl
					</td>
				</tr>
				<tr>
					<td>
						Digital Magics
					</td>
					<td>
						Spa
					</td>
				</tr>
				<tr>
					<td>
						Giacomo
					</td>
					<td>
						Corsini
					</td>
				</tr>
				<tr>
					<td>
						Mario
					</td>
					<td>
						Gianella
					</td>
				</tr>
				<tr>
					<td>
						Giovanni
					</td>
					<td>
						Sardagna
					</td>
				</tr>
				<tr>
					<td>
						Tiare
					</td>
					<td>
						Srl
					</td>
				</tr>
				<tr>
					<td>
						Alberto
					</td>
					<td>
						Tiradossi
					</td>
				</tr>
				<tr>
					<td>
						Alessandro
					</td>
					<td>
						Pantina
					</td>
				</tr>
				<tr>
					<td>
						Michela
					</td>
					<td>
						Petronio
					</td>
				</tr>
				<tr>
					<td>
						Luca
					</td>
					<td>
						Barilla
					</td>
				</tr>
				<tr>
					<td>
						Vincenzo
					</td>
					<td>
						Cioffi
					</td>
				</tr>
				<tr>
					<td>
						Giuliana
					</td>
					<td>
						Gorla
					</td>
				</tr>
				<tr>
					<td>
						Alberto Maria
					</td>
					<td>
						Birolini
					</td>
				</tr>
			</table>			

			g) elenco delle società partecipate;
			 
			h) indicazione dei titoli di studio e delle esperienze professionali dei soci e del personale la cui prestazione lavorativa è connessa all’attività innovativa delle PMI, esclusi eventuali dati sensibili;

			I GRECO NICOLETTA LAUREA (VECCHIO ORDINAMENTO), CONSEGUITA IN 07/1998, UNIVERSITÀ COMMERCIALE LUIGI BOCCONI - MASTER MBA, CONSEGUITO NEL 2004, UNIVERSITÀ DI NAVARRA
			TITOLI DI STUDIO:
			- BRUTTINI - TITOLO DI STUDIO LAUREA SPECIALISTICA, 07/2009, UNIVERSITÀ DEGLI STUDI DI SIENA, SIENA;
			- BRUNO - TITOLO DI STUDIO LAUREA TRIENNALE, 11/2008, UNIVERSITÀ DEGLI STUDI DI TORINO, TORINO;
			- CIOFFI - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), 05/2000, UNIVERSITÀ DEGLI STUDI DI NAPOLI, NAPOLI;
			- DIGITAL MAGICS S.P.A. - SOCIETÀ DI CAPITALI
			- TIRADOSSI - TITOLO DI STUDIO LAUREA SPECIALISTICA, 09/2015, UNIVERSITÀ DEGLI STUDI DI TORINO, TORINO;
			- PANTINA - TITOLO DI STUDIO LAUREA SPECIALISTICA, 07/2009, UNIVERSITÀ DEGLI STUDI DI TORINO, TORINO;
			- CORSINI - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), 04/1991, CAMBRIDGE UNIVERSITY, CAMBRIDGE (UK);
			- GIANELLA - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), 06/1991, UNIVERSITÀ DEGLI STUDI DI PAVIA, PAVIA;
			- SARDAGNA - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), 10/1995, UNIVERSITÀ DEGLI STUDI DI PAVIA, PAVIA;
			- TIARE S.R.L. - SOCIETÀ DI CAPITALI
			- SARAVAL - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), FACOLTÀ DI INGEGNERIA ELETTRONICA, 02/1990, POLITECNICO DI MILANO, MILANO;
			- RITUCCI - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), FACOLTÀ DI INGEGNERIA;
			- BARILLA - TITOLO DI STUDIO DIPLOMA DI MATURITÀ;
			- PETRONIO - TITOLO DI STUDIO LAUREA, FACOLTÀ DI SCIENZE DELLE PREPARAZIONI ALIMENTARI, 11/1990, UNIVERSITÀ DEGLI STUDI DI MILANO;
			- PANDA S.R.L. - SOCIETÀ DI CAPITALI
			- GORLA - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), FACOLTÀ DI ECONOMIA E COMMERCIO, 02/1991, UNIVERSITÀ BOCCONI, MILANO;
			- BIROLINI - TITOLO DI STUDIO LAUREA (VECCHIO ORDINAMENTO), FACOLTÀ DI ECONOMIA E COMMERCIO, 06/2001, UNIVERSITÀ BOCCONI, MILANO.

			DIPENDENTI:
			- BOMBARDIERI - TITOLO DI STUDIO LAUREA MAGISTRALE, FACOLTÀ DI SCIENZE LINGUISTICHE, 02/2013, UNIVERSITÀ CATTOLICA, MILANO;
			- TERRI - TITOLO DI STUDIO LAUREA, FACOLTÀ DI CANTO LIRICO, 09/2015, CONSERVATORIO DI MUSICA "NINO ROTA", MONOPOLI, BARI;
			- PORCU - TITOLO DI STUDIO LAUREA E MASTER UNIVERSITARIO DI I LIVELLO, 09/2011, UNIVERSITÀ DEGLI STUDI DI PISA, PISA;
			- RIVIDDI - TITOLO DI STUDIO LAUREA, 11/2008, UNIVERSITÀ DEGLI STUDI DI CATANIA, CATANIA;
			- SVISTUNOVA - TITOLO DI STUDIO LAUREA (ESTERA), 05/2014, RUSSIA;
			- TALLIA - TITOLO DI STUDIO LAUREA MAGISTRALE, 05/2015, UNIVERSITÀ BOCCONI, MILANO.

			ESPERIENZE LAVORATIVE
			A. DANIELE BRUTTINI - HA MATURATO ESPERIENZA IN AZIENDE INTERNAZIONALI, SIA IN ITALIA CHE ALL'ESTERO, NELL'AMBITO DI BUSINESS DIGITALI E E-COMMERCE;
			B. ANDREA BRUNO - HA LAVORATO, SIA IN ITALIA CHE ALL'ESTERO, IN AZIENDE DIGITALI E E-COMMERCE, CON PARTICOLARE RIFERIMENTO AD AMBITI DI LOGISTICA PER E-COMMERCE E USER EXPERIENCE;
			C. CHIARA BOMBARDIERI - FOOD BLOGGER, HA SVILUPPATO IN QUOMI COMPETENZE SPECIFICHE PER LA CREAZIONE DELLE RICETTE CHE QUOMI PROPONE AI PROPRI CLIENTI;
			D. TERRJ PAVONE - CON UN MASTER IN ECOMMERCE ALLA TAG INNOVATION SCHOOL, SI OCCUPA DI CUSTOMER EXPERIENCE PER QUOMI;
			E. PORCU MAURIZIO - CON ESPERIENZE PASSATE IN AGENZIE DI DIGITAL MARKETING E DI RESPONSABILE MARKETING IN UN'ALTRA STARTUP, MAURIZIO E' IL RESPONSABILE MARKETING DI QUOMI;
			F. RIVIDDI MARIA LUISA - HA AVUTO ESPERIENZE LAVORATIVE IN ALTRE SOCIETÀ DI E-COMMERCE E FOOD DELIVERY COME RESPONSABILE DEL SERVIZIO CLIENTI, STESSA ATTIVITÀ DI CUI SI OCCUPA IN QUOMI;
			G. TALLIA GALOPPO GIOVANNI - HA ESPERIENZA DI PRODUCT MANAGER IN BRAND CONSUMERS, IN QUOMI HA IL RUOLO DI MERCHANDISER.

			i) indicazione dell’esistenza di relazioni professionali, di collaborazione o commerciali con incubatori certificati, investitori istituzionali e professionali, università e centri di ricerca;
			 
			l) ultimo bilancio depositato, nello standard XBRL (<a href="../../static/Quomi_Bilancio_e_NI_2017_firmato.pdf" class="link-detail" download>scrica bilancio</a>);
			 
			m) elenco dei diritti di privativa su proprietà industriale e intellettuale;
			 
			n) numero dei dipendenti: 6
			 
			o) sito internet: www.quomi.it
		</section>
	</div>
</template>
<script>

export default {
	
}
</script>

<style scoped>
.container {
	overflow-wrap: break-word;
	word-wrap: break-word;
	-ms-word-break: break-all;
	/* This is the dangerous one in WebKit, as it breaks things wherever */
	word-break: break-all;
	/* Instead use this non-standard one: */
	word-break: break-word;
	/* Adds a hyphen where the word breaks, if supported (No Blink) */
	-ms-hyphens: auto;
	-moz-hyphens: auto;
	-webkit-hyphens: auto;
	hyphens: auto;
}


.header {
	font-size: 30px;
	text-align:center;
	margin-bottom: 10px;
}

.content {
	padding: 20px 0;
	color: #575A5C;
	margin: 0 auto;
	width: 90%;
	max-width: 1024px;
	white-space: pre-line;
}
h1 {
	font-size: 30px;
	font-weight: bold;
	text-align:center;
	margin-bottom: 10px;
}
h2 {
	font-size: 23px;
	text-align:center;
	margin-bottom: 10px;
}
p {
	font-size: 15px;
	text-align:justify;
	margin-bottom: 10px;
}
ul {
	font-size: 15px;
	text-align:justify;
	margin-left: 40px;
	list-style: initial;
}

table {
	border: 1px solid;
	white-space: normal;
}

table td {
	border: 1px solid;
	padding: 10px;
}


</style>
